module.exports = __webpack_public_path__ + "03_veryshort_gold.00e59cd1.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/kanai/male/layer5/03_veryshort_gold.png
// module id = +XVm
// module chunks = 0